import { visuallyHidden } from '@lastbrand/web-ui-styled-system/patterns'
import { Fragment } from 'react'

import { NO_COLOR_OPTION_NAME } from '@src/quince-site-common/src/constants/app'

import type { ProductTileTitleProps } from './title.types'

/**
 * Accessible product title for design-system tiles: optionally prepends a screen-reader-only color name.
 */
export function ProductTileTitle({ title, colorDisplayName, renderLink }: ProductTileTitleProps) {
  const exposeColorToScreenReader =
    colorDisplayName && colorDisplayName.toLowerCase() !== NO_COLOR_OPTION_NAME.toLowerCase()

  // Use Panda's `visuallyHidden` pattern, not the legacy `sr-only` class:
  // `src/quince-styles/scss/common.scss` scopes `.sr-only` under
  // `:where(html:not([data-styles='panda']))`, so on a panda-scoped page
  // (where this DS tile renders) the class has no CSS and the color name
  // would render visibly before the title.
  const accessibleProductName = exposeColorToScreenReader ? (
    <>
      <span className={visuallyHidden()}>{colorDisplayName}&nbsp;</span>
      {title}
    </>
  ) : (
    title
  )

  const content = renderLink ? renderLink(accessibleProductName) : accessibleProductName

  return <Fragment>{content}</Fragment>
}
